import { Component, OnInit } from '@angular/core';
import { Hotkey, HotkeysService } from 'angular2-hotkeys';
import { FormControl, Validators } from '@angular/forms';

import { Router } from '@angular/router';
import { ToastMessage } from '../../toast-message/toast-message.service';
import { DataService } from '../../data.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { BasicInfoService } from '../../onboarding-page/basic-info/basic-info.service';

@Component({
  selector: 'app-search-fleet',
  template: require('./search-fleet.component.html'),
  providers: [ToastMessage, DataService, BasicInfoService]
})
export class SearchFleetComponent implements OnInit {

  public fleetMobile: any;
  public fleetVehicle: any;
  public fleetId: any;
  public overHeadPanelTitle = 'Fleet Onboarding';
  mobileFormControl = new FormControl('', [
    Validators.pattern('[0-9]{10}')
  ]);

  constructor(
    private router: Router,
    private toastMessage: ToastMessage,
    private dataService: DataService,
    private hotkeysService: HotkeysService,
    private spinnerService: Ng4LoadingSpinnerService,
    private _basicInfoService: BasicInfoService,
    private _toastMessage: ToastMessage,
  ) {
    if (this.dataService.toBeReload) {
      window.location.reload();
    }
    this.hotkeysService.add(new Hotkey(['m', 'M'], (event: KeyboardEvent): boolean => {
      document.getElementById('search-mobile').click();
      return false;
    }));
  }

  ngOnInit() {
  }

  goBack() {
    this.router.navigate(['/onboardFleet']);
  }

  searchFleetByMobileAndVehicle() {
    let response;
    if (this.mobileFormControl.errors && this.mobileFormControl.errors.pattern) {
      this.toastMessage.openSnackBarError('Please enter a valid mobile number');
    }else {
      this.spinnerService.show();
      this._basicInfoService.getFleetVehicleData(this.fleetMobile, this.fleetVehicle, 10, 0).subscribe(res => {
        response = res;
        if (response.data) {
          this.spinnerService.hide();
          this._toastMessage.openSnackBarSuccess('Vehicle data found');
          this.router.navigate(
            ['/fleetVehicleList'],
            { queryParams: { mobile: this.fleetMobile, number: this.fleetVehicle, fleetId:response.fleetId, mode: response.mode, modeId:response.modeId} }
          );
        } else {
          this.spinnerService.hide();
          this._toastMessage.openSnackBarError('Please enter mobile/vehicle number');
        }
      },
      err => {
        this.spinnerService.hide();
        if (typeof err === 'string') {
          return this._toastMessage.openSnackBarError(err);
        }
        this._toastMessage.openSnackBarError('Could not get vehicle details.');
        console.log(err);
      });
    }
  }

}
